/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Rag_Project_Inherit_From_OrgInputs */



/**
* | output |
* | --- |
* | "Inherit from organisation (currently {value})" |
*
* @param {Rag_Project_Inherit_From_OrgInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_project_inherit_from_org = /** @type {((inputs: Rag_Project_Inherit_From_OrgInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Project_Inherit_From_OrgInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Von Organisation übernehmen (derzeit ${i?.value})`)
	return /** @type {LocalizedString} */ (`Inherit from organisation (currently ${i?.value})`)
});